import styled from "styled-components";

export default styled.div`
  code {
    font-size: 0.7rem;
    color: #172b4d;
  }
  margin-right: 30px;
`;
